module.exports = __webpack_public_path__ + "static/people_img24-246131231f9a0ccd016facbdadce520c.png";